/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Disp_Density_CompactInputs */

const en_disp_density_compact = /** @type {(inputs: Disp_Density_CompactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compact`)
};

const de_disp_density_compact = /** @type {(inputs: Disp_Density_CompactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kompakt`)
};

/**
* | output |
* | --- |
* | "Compact" |
*
* @param {Disp_Density_CompactInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const disp_density_compact = /** @type {((inputs?: Disp_Density_CompactInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Disp_Density_CompactInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_disp_density_compact(inputs)
	return en_disp_density_compact(inputs)
});